import { useState} from "react"
import { DescriptionItem, ProductMetafields} from "~/types"
import Construction from "~/assets/icons/Construction";
import Dimensions from "~/assets/icons/Dimensions";
import Details from "~/assets/icons/Details";
import Overview from "~/assets/icons/Overview";
import OtherDetails from "~/assets/icons/OtherDetails";
import Shipping from "~/assets/icons/Shipping";

type DescriptionTabsProps = 
{
    product: ProductMetafields
}

export default function DescriptionTab({ product}: DescriptionTabsProps) 
{
    const descriptionTabs  : DescriptionItem[] = product.bodyHtmlTabs?.value != undefined ? JSON.parse(product.bodyHtmlTabs?.value) : [];
    const [description, setDescription] = useState<DescriptionItem>(descriptionTabs[0]);
    const [isActive, setActive] = useState<string>(descriptionTabs[0]?.title ? descriptionTabs[0]?.title : "");

    const changeDescription = (descriptionTab : DescriptionItem) => 
    {
        setActive(descriptionTab?.title);
        setDescription(descriptionTab);
    }
    const getIcon = (descriptionTab : DescriptionItem) => 
    {
        switch (descriptionTab.title.trim())
        {
            case "Overview":
                return <Overview/>;
            case "Dimensions":
                return <Dimensions/>;
            case "Details":
                return <Details/>;
            case "Other Details":
                return <OtherDetails/>;
            case "Construction":
                return <Construction/>;
            case "Shipping":
                return <Shipping/>
            default:
                return <Overview/>;
        }
    }
    return (
        <div className="description-container description-container-tabs">
            {(descriptionTabs).map((dt:DescriptionItem, i:number) => (
                <button className={`description-item-button cursor-pointer inline-block ${isActive == dt?.title ? "description-button-active" : ""}`}
                onClick={() => changeDescription(dt)}>
                    <div className="elementWrapper">
                    {getIcon(dt)}
                    <span className={"description-item-button-title"}>{dt?.title}</span>
                    </div>
                </button>
            ))}
            <div className={"description-body-container"}>
                <p className="description-body-title">{description?.title}</p>
                <div className={"description-body"}dangerouslySetInnerHTML={{ __html: description?.body }}></div>  
            </div>
        </div>
    )
}